import { GameGenres } from './enums';
import { AppGame, UserGame } from './types';

export const getGameGenreColor = (gameGenre: GameGenres): string => {
  switch (gameGenre) {
    case GameGenres.adventure:
      return '#09cb79';
    case GameGenres.survival:
      return '#fc4154';
    case GameGenres.popular:
      return '#09cb79';
    case GameGenres.infiniteRun:
      return '#f0c43d';
    case GameGenres.platformer:
      return '#0b6cf1';
    case GameGenres.addictive:
      return '#e94d89';
    case GameGenres.fast:
      return '#ee9502';
    case GameGenres.fastPace:
      return '#ee9502';
    case GameGenres.game3d:
      return '#233058';
    default:
      return '#c70786';
  }
};

export const isGameInProgress = (userGame: UserGame): boolean => userGame.score.highest > 0;

export const getGameGemsProgress = (appGame: AppGame, userGame: UserGame): number => userGame.step / appGame.steps.count;
export const getGameExpProgress = (appGame: AppGame, userGame: UserGame): number => userGame.points.exp / appGame.points.exp;

export const isGameGemsCompleted = (appGame: AppGame, userGame: UserGame): boolean => {
  if (appGame.points.gems > 0) {
    return userGame.points.gems >= appGame.points.gems;
  }
  return userGame.score.highest >= (appGame.steps.count * appGame.steps.size);
};

export const isGameExpCompleted = (appGame: AppGame, userGame: UserGame): boolean => userGame.points.exp >= appGame.points.exp;

export const isGameCompleted = (appGame: AppGame, userGame: UserGame): boolean => isGameExpCompleted(appGame, userGame) && isGameGemsCompleted(appGame, userGame);

export const isGameStarted = (appGame: AppGame, userGame: UserGame): boolean => isGameCompleted(appGame, userGame) || isGameInProgress(userGame);

export const getGameUrl = (appGameUrl: string, user?: string): string => `${appGameUrl}${user ? '/?userId='.concat(user) : ''}`;
